import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { Button } from "reactstrap";

import { useTranslation } from "react-i18next";

function ChangeUsernamePage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [username, setUsername] = useState();
  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setUserData(data);
      setUsername(data.username);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  const changeUsername = async () => {
    if (userData.canEditUsername) {
      setIsLoading(true);

      try {
        const userRef = query(
          collection(db, "users"),
          where("uid", "==", user?.uid)
        );
        const findUsers = await getDocs(userRef);
        findUsers.forEach(async (userObject) => {
          const getUser = doc(db, "users", userObject.id);
          await updateDoc(getUser, {
            username: username,
            canEditUsername: false,
          });
        });

        setIsLoading(false);
      } catch (err) {
        console.error(err);
        alert(err.message);

        setIsLoading(false);
      }
    } else {
      Swal.fire({
        text: "Sorry, you can only change your username once.",
        icon: "error",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
    }
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="changeUsernamePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("changeUsername").toUpperCase()}
      </h1>
      <div>
        <input
          type="text"
          className="mainInput"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder={t("yourUsername")}
          style={{ marginBottom: "1rem" }}
        />
        <Button
          onClick={changeUsername}
          className="primaryBtn"
          style={{ width: "100%" }}
          disabled={username === userData?.username}
        >
          {t("changeBanner").toUpperCase()}
        </Button>
      </div>
    </div>
  );
}

export default ChangeUsernamePage;
